import { observer } from "mobx-react";
import * as React from "react";
import { getJobCategoryOptions } from "../../constants";
import { applicationStore } from "../../stores/ApplicationStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { optionToString } from "../util/helpers";
import { ContentWrapper } from "./ContentWrapper";
import { THEME } from "../../theme/ThemeStore";

type Props = { imageUrl: string };

export const TopImage = observer(({ imageUrl }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                width: "100%",
                height: isMobile ? 95 : "100%",
                maxHeight: 280,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: THEME.THEME_NAME === "dal" ? "center center" : "center top",
                display: "flex"
            }}
        >
            <ContentWrapper style={{ flexDirection: "column", justifyContent: "flex-end" }}>
                <h2
                    style={
                        isMobile
                            ? {
                                  fontSize: 22,
                                  lineHeight: "28px",
                                  marginBottom: 0
                              }
                            : {
                                  marginBottom: 20
                              }
                    }
                    className="topImageHeader"
                >
                    {THEME.THEME_NAME === "aaa" &&
                        optionToString(getJobCategoryOptions(), applicationStore.currentApplication.jobCategory)}
                </h2>
            </ContentWrapper>
        </div>
    );
});
